import { jsx } from "react/jsx-runtime";
import { startOfWeek, addDays, getWeek, format } from "date-fns";
import { useDateFnsLocale } from "../../appointments-picker.helpers.js";
import { CurrentPeriod as CurrentPeriod$1 } from "./CurrentPeriod.styles.js";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "@mui/material/styles";
const CurrentPeriod = ({ dates, lang, labels }) => {
  const locale = useDateFnsLocale(lang);
  if (dates.length === 0)
    return null;
  const firstDateOfWeek = startOfWeek(dates[0], { weekStartsOn: 1 });
  const lastWorkingDayOfWeek = addDays(firstDateOfWeek, 4);
  const weekNumber = getWeek(dates[0], { weekStartsOn: 1 });
  const formattedStartDate = format(firstDateOfWeek, "dd MMM", { locale });
  const formattedEndDate = format(lastWorkingDayOfWeek, "dd MMM yyyy", { locale });
  const formattedWeek = `${labels.week} ${weekNumber}: ${formattedStartDate} - ${formattedEndDate}`;
  return /* @__PURE__ */ jsx(CurrentPeriod$1, { children: formattedWeek });
};
export {
  CurrentPeriod as default
};
